/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular-ivy';

import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import { environment } from '@environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  // Bootstrap-Fehler mit Sentry erfassen (falls initialisiert)
  Sentry.captureException(err);
  // Trotzdem werfen um sicherzustellen dass App in Dev sichtbar fehlschlägt
  throw err;
});
